import { render, staticRenderFns } from "./handItemEn.vue?vue&type=template&id=223bf8d5"
import script from "./handItemEn.vue?vue&type=script&lang=js"
export * from "./handItemEn.vue?vue&type=script&lang=js"
import style0 from "./handItemEn.vue?vue&type=style&index=0&id=223bf8d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports